import { useState, useEffect } from "react";

export const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.statusText);
        const json = await response.json();
        setData(json);
        window.sessionStorage.setItem("clientIpAddress", json.ip_addr);
        setError(null);
      } catch (error) {
        setError(`${error} Could not Fetch Data `);
      }
    };
    fetchData();
  }, [url]);
  return { data, error };
};
